import {
  CreateRequestForQuotationRequest,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { GetContext } from 'store/storeUtils'
import { OutgoingRfqsController } from '../RFQ/OutgoingRfqsController'
import { RFQLine } from './Components/ProjectRFQLines'

export class ProjectRFQController extends OutgoingRfqsController {
  private _projectId: string
  constructor() {
    super()
    this._projectId = GetContext().projectId
  }

  public async getProjectRFQs() {
    return this.listCanonical(this._projectId)
  }

  public async createRequestForQuotation(draftRFQLines: RFQLine[]) {
    try {
      const request: CreateRequestForQuotationRequest = {
        buyerProjectId: this._projectId,
        bomItemAndActivities: draftRFQLines.map((line) => ({
          bomItemId: line.bomItemPointer.id,
          activities: (line.activities ?? [])
            .filter((activity) => activity.selected)
            .map((activity) => ({
              buyerActivityId: activity.activityId,
              workingStepType: activity.workingStepType,
            })),
        })),
      }

      return await this.createCanonical(request)
    } catch (err) {
      throw this.HandleError(err)
    }
  }
}
